import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBaj0kd-VXYTlc26_qMz5cwmS_Z7Qulpg0",
  authDomain: "replace-order-app.firebaseapp.com",
  projectId: "replace-order-app",
  storageBucket: "replace-order-app.appspot.com",
  messagingSenderId: "74411731627",
  appId: "1:74411731627:web:ce44a2fcda965d7ddda5ee"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
